import { cn } from '@tempo-io/sui-class-utils';
import React from 'react';
import { SanitizedHtml } from './components/SanitizedHtml';
import './styles/rich-text-display.css';
import type { RichTextDisplayProps } from './types';

export const RichTextDisplay = React.memo<RichTextDisplayProps>(({ value, className }) => {
  if (!value.trim()) {
    return null;
  }

  return (
    <div className={cn('rich-text-display text-sm text-text-neutral-primary p-2', className)}>
      <SanitizedHtml content={value} />
    </div>
  );
});
